<template>
  <apply-score-model
    v-if="showScoreModelDropdown && (isActive || !item.context)"
    :context="item.context"
    @apply="applyContext"
  />
  <apply-date-scope
    v-else-if="requiresMonthsLookbackPicker && (isActive || !item.context)"
    :context="item.context"
    @apply="applyContext"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";

import { useAttributeBuilderStore } from "@/stores/customAttributeBuilder";

import ApplyDateScope from "@/components/customAttributes/formula/ApplyDateScope.vue";
import ApplyScoreModel from "@/components/customAttributes/formula/ApplyScoreModel.vue";

import type {
  IAttribute,
  IContextSetValueModel,
  IStepAttribute,
} from "@/models/orchestration";

const props = withDefaults(
  defineProps<{
    item: IStepAttribute;
    attribute: IAttribute | null;
    isActive: boolean;
  }>(),
  {
    attribute: null,
    isActive: false,
  }
);

const { setContext } = useAttributeBuilderStore();

const showScoreModelDropdown = computed(() => {
  return !!props?.attribute?.options?.consumer_score_models_levels;
});

const requiresMonthsLookbackPicker = computed(() => {
  return !!props?.attribute?.options?.month_picker_range;
});

const applyContext = (context: IContextSetValueModel) => {
  setContext(props.item, context);
};
</script>
